import { ArrowLeft } from 'lucide-react'
import { navigate } from '../../lib/router'
import { useAuthStore } from '../../lib/auth-store'
import { PublicHeader } from '../../components/marketing/PublicHeader'
import { Footer } from '../../components/Footer'
import { Button } from '../../components/ui/button'

export function ImpressumPage() {
  const accessToken = useAuthStore((s) => s.accessToken)
  return (
    <div className="flex min-h-svh flex-col bg-background text-foreground">
      <PublicHeader loggedIn={!!accessToken} />
      <main className="mx-auto w-full max-w-3xl flex-1 px-6 pt-32 pb-24">
        <article className="space-y-6 text-base leading-relaxed">
          <Button variant="ghost" size="sm" onClick={() => navigate('/')} className="-ml-2 text-muted-foreground">
            <ArrowLeft /> Back
          </Button>

          <header className="space-y-2">
            <h1 className="text-3xl font-semibold tracking-tight">Impressum</h1>
            <p className="text-sm text-muted-foreground">Angaben gemäß § 5 TMG</p>
          </header>

          <section className="space-y-2">
            <h2 className="text-2xl font-semibold tracking-tight">Anbieter</h2>
            <p>
              Applox GmbH<br />
              [STRASSE UND HAUSNUMMER]<br />
              [PLZ ORT]<br />
              Deutschland
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-2xl font-semibold tracking-tight">Vertretungsberechtigte Geschäftsführer</h2>
            <p>[GESCHÄFTSFÜHRER NAME(N)]</p>
          </section>

          <section className="space-y-2">
            <h2 className="text-2xl font-semibold tracking-tight">Registereintrag</h2>
            <p>
              Registergericht: [AMTSGERICHT]<br />
              Registernummer: [HRB NUMMER]
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-2xl font-semibold tracking-tight">Umsatzsteuer-ID</h2>
            <p>
              Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG:<br />
              [UST-IDNR]
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-2xl font-semibold tracking-tight">Kontakt</h2>
            <p>
              E-Mail: hello@doable.website<br />
              Telefon: [TELEFONNUMMER]
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-2xl font-semibold tracking-tight">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <p>
              [GESCHÄFTSFÜHRER NAME]<br />
              [STRASSE UND HAUSNUMMER]<br />
              [PLZ ORT]
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-2xl font-semibold tracking-tight">Streitschlichtung</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit:{' '}
              <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer" className="text-primary underline underline-offset-4">
                https://ec.europa.eu/consumers/odr
              </a>
              .<br />
              Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind nicht
              bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>
        </article>
      </main>
      <Footer variant="site" />
    </div>
  )
}
